//@ts-check
/* global $ */
import { Plan } from "@functions/plans/types";

export async function purchaseNewLimit({
    isAnnual,
    upsellPriceId,
    annualPriceId,
    priceId,
    quantity,
    workspaceId = null,
    subscriptionType = Plan.LegacyStarter
}) {
    const workspace = workspaceId || window.currentWorkspace;
    let price;
    if (isAnnual) {
        if (annualPriceId) {
            price = annualPriceId;
        } else if (upsellPriceId) {
            price = upsellPriceId;
        } else {
            return { ok: false };
        }
    } else {
        if (!priceId) {
            return { ok: false };
        }
        price = priceId;
    }
    const response = await fetch("/query/subscriptions", {
        method: "POST",
        cache: "no-cache",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            workspaceId: workspace,
            subscriptionType,
            products: [{ price, quantity }]
        })
    });
    if (response.ok) {
        const json = await response.json();
        return { ok: true, data: json.result };
    }
    return { ok: false };
}

export async function getSubscriptionInfo(workspaceId) {
    const workspace = workspaceId || window.currentWorkspace;
    const response = await fetch(`/query/subscriptions?workspaceId=${workspace}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
    });
    if (response.ok) {
        const data = await response.json();
        return data;
    }
}

export async function getPaymentMethods(workspaceId) {
    const workspace = workspaceId || window.currentWorkspace;
    const response = await fetch(`/query/paymentMethods?workspaceId=${workspace}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
    });
    if (response.ok) {
        const data = await response.json();
        return data?.paymentMethods || [];
    }
}

export async function reactivatePaidPlanSubscription(workspaceId) {
    const data = { workspaceId: workspaceId || window.currentWorkspace };
    const result = await $.post("/query/subscriptions/reactivate", data, "JSON");
    return result;
}

export async function cancelPaidPlanSubscription(workspaceId) {
    const data = { workspaceId: workspaceId || window.currentWorkspace };
    const result = await $.post("/query/subscriptions/cancel", data, "JSON");
    return result;
}

export async function acceptCancelOffer(offer, fsrc, workspaceId) {
    const data = { workspaceId: workspaceId || window.currentWorkspace, offer, fsrc };
    const result = await $.post("/query/subscriptions/acceptCancelOffer", data, "JSON");
    return result;
}

export async function schedulePlanDowngrade(downgradePlan, workspaceId) {
    const data = { downgradePlan, workspaceId: workspaceId || window.currentWorkspace };
    const response = await fetch("/query/subscriptions/schedulePlanDowngrade", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
    });
    return response.json();
}

export default {
    purchaseNewLimit,
    getSubscriptionInfo,
    getPaymentMethods,
    reactivatePaidPlanSubscription,
    cancelPaidPlanSubscription,
    acceptCancelOffer,
    schedulePlanDowngrade
};
